// extracted by mini-css-extract-plugin
export var inner = "HeroImage-module--inner--27d7f";
export var isSerif = "HeroImage-module--isSerif--aa47f";
export var wrapper = "HeroImage-module--wrapper--f3d98";